import "../assets/link.scss";
import {Link} from "react-router-dom";

/**
 * Компонент внутренней ссылки. Переход по ссылке происходит с использованием
 * роутера приложения.
 * 
 * @param {*} props 
 * @returns 
 */
export function LinkInternal(props) {
  const {
    to,
    children = [],
    className = null,
  } = props;

  return <Link className={className} to={to}>{children}</Link>;
}